import Main from "./components/Popup.vue";

export default Vue => {
  return {
    run({ header, message, image, buttonText = "OK", type = "success", buttonCallBack = () => {} }) {
      var Element = Vue.extend(Main);
      // let self = this
      let el = new Element({
        data: {
          message,
          buttonText,
          header,
          type,
          image,
          buttonCallBack,
        },
      });
      let body = document.querySelector("#app");
      let area = document.createElement("div");
      body.appendChild(area);
      el.$mount(area);
    },
  };
};
